"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.concentrationLimitPointerMethods = void 0;
/* eslint-disable no-param-reassign */
const lodash_1 = __importDefault(require("lodash"));
const calc_agent_1 = require("@finley-technologies/calc-agent");
const common_1 = require("@finley-technologies/common");
const getPointerImplementation = (concentrationLimitKey, baseFieldName, concentrationLimitFunction) => ({ concentrationReceivables, valueConfig, totalConcentrationExposure, }) => {
    (0, common_1.finleyAssert)(valueConfig.type === 'number', `unsupported concentration limit type in concentration limit ${concentrationLimitKey}`);
    const defaultConcentrationLimit = valueConfig.limit;
    const concentrationLimitValueType = valueConfig.valueType;
    (0, common_1.finleyAssert)(lodash_1.default.every(concentrationReceivables, (rec) => lodash_1.default.isString(rec.baseFields[baseFieldName])), new common_1.error.FinleyError(`baseFields.${baseFieldName} must be defined to run kafeneTpg1.${concentrationLimitKey}`));
    const groupedReceivables = lodash_1.default.groupBy(concentrationReceivables, (rec) => rec.baseFields[baseFieldName]);
    const standardBorrowingBaseReductions = lodash_1.default.map(lodash_1.default.entries(groupedReceivables), ([groupId, receivables]) => {
        let concentrationLimit = defaultConcentrationLimit;
        if (concentrationLimitFunction) {
            concentrationLimit = concentrationLimitFunction(groupId, defaultConcentrationLimit);
        }
        return (0, calc_agent_1.calculateStandardConcentrationLimitKickouts)({
            concentrationLimit,
            totalConcentrationExposure,
            concentrationReceivables: receivables,
            concentrationLimitValueType,
        });
    });
    // accumulate all breaches into a single standard borrowing base reduction
    let concentrationAmount = 0;
    const concentrationKickouts = lodash_1.default.reduce(standardBorrowingBaseReductions, (result, { calculations, kickouts }) => {
        const _result = { ...result };
        lodash_1.default.forEach(lodash_1.default.toPairs(kickouts), ([finleyReceivableId, kickout]) => {
            if (kickout === 0)
                return true;
            concentrationAmount += calculations.concentrationAmount || 0;
            if (!_result[finleyReceivableId]) {
                _result[finleyReceivableId] = 0;
            }
            _result[finleyReceivableId] += kickout;
            return true;
        });
        return _result;
    }, {});
    return {
        kickouts: concentrationKickouts,
        calculations: {
            concentrationAmount,
            concentrationLimit: standardBorrowingBaseReductions.length > 0
                ? standardBorrowingBaseReductions[0].calculations.concentrationLimit
                : 0,
            concentration: standardBorrowingBaseReductions.length > 0
                ? standardBorrowingBaseReductions[0].calculations.concentration
                : 0,
        },
    };
};
exports.concentrationLimitPointerMethods = [
    // No more than 1% of Financed Portfolio to the same obligors
    {
        method: 'kafeneTpg1.anySingleObligor',
        pointerImplementation: getPointerImplementation('anySingleObligor', 'application_id'),
    },
    // No more than 45% of lease balances consist of leases with account obligors domiciled in any single state
    {
        method: 'kafeneTpg1.anySingleState',
        pointerImplementation: getPointerImplementation('anySingleState', 'state'),
    },
    // No more than 10% of lease balances are from a single qualified lease inventory dealer
    {
        method: 'kafeneTpg1.anySingleQualifiedLeaseInventoryDealer',
        pointerImplementation: getPointerImplementation('anySingleQualifiedLeaseInventoryDealer', 'merchant_id'),
    },
    // No more than 75% leases in a single vertical
    {
        method: 'kafeneTpg1.anySingleVertical',
        pointerImplementation: getPointerImplementation('anySingleVertical', 'store_category_name'),
    },
];
//# sourceMappingURL=concentrationLimitPointerMethods.js.map